<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="row align-items-end" style="padding-top: 1rem; padding-left: 1rem;">
      <!-- STORE -->

      <!-- MAGASIN / CLIENT -->
      <div class="col-md-4 mb-3">
        <label>Magasin</label>
        <v-select
          v-model="client_filter"
          :options="customerList"
          label="name"
          placeholder="Tous les magasins"
          @search="filterClients"
        >
          <template #no-options>
            Taper un mot pour chercher un client
          </template>
        </v-select>
      </div>

      <!-- STATUT -->
      <div class="col-md-4 mb-3">
        <label>Statut</label>
        <select v-model="status_filter" class="form-control">
          <option value="">Tous</option>
          <option :value="0">Brouillon</option>
          <option :value="1">Enregistré</option>
          <option :value="2">Payé</option>
        </select>
      </div>

      <!-- TYPE DE DATE -->
      <div class="col-md-4 mb-3">
        <label>Date de</label>
        <select v-model="date_type_filter" class="form-control">
          <option value="CREATION_DATE">Date de création</option>
          <option value="PAYMENT_DATE">Date de paiement</option>
        </select>
      </div>

      <!-- DATE RANGE -->
      <div class="col-md-4 mb-3">
        <label>Période</label>
        <div class="border p-2 cursor-pointer" @click="showCalendar()">
          {{ selectedDate?.[0]?.format("DD MMM YYYY") || "—" }}
          -
          {{ selectedDate?.[1]?.format("DD MMM YYYY") || "—" }}
          <i class="flaticon-calendar float-end"></i>
        </div>

        <div
          v-show="showCalendarBox"
          class="position-relative mt-2 p-2 bg-white shadow rounded"
          style="z-index: 999"
        >
          <MyDateRangePicker
            v-model="selectedDate"
            @onSelect="showCalendar"
            :enableSecondCalendar="true"
          />
        </div>
      </div>

      <!-- TOTAL -->
      <div class="col-md-4 mb-3">
        <label>Total</label>
        <select v-model="total_filter" class="form-control">
          <option value="">Tous</option>
          <option value="MORE1">Plus de 10 000</option>
          <option value="MORE">Plus de 100</option>
          <option value="LESS">Moins de 100</option>
          <option value="ZERO">Égal à 0</option>
        </select>
      </div>

      <!-- ACTIONS -->
      <div class="col-md-4 mb-3 d-flex flex-wrap gap-2">
        <button class="btn btn-primary" @click="applyFilters">Filtrer</button>
        <button class="btn btn-outline-danger" @click="resetFilters">
          Annuler
        </button>
      </div>
    </div>

    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          to="/add-invoices"
          v-if="auth.can('ADD_INV')"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Nouvelle Facture
        </router-link>
        <button
          v-if="auth.can('ADD_INV')"
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-info-subtle fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
          @click="autoAddInvoices"
          :disabled="load"
        >
          <div class="spinner-border" v-if="load" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>

          <i class="flaticon-menu-2 position-relative ms-5 top-2 fs-15"></i>
          Auto-Ajout des factures
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Search invoice"
        />

        <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table
        :columns="columns"
        :rows="rows"
        responsive
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Factures Sélectionées',
          disableSelectInfo: true,
        }"
        @selected-rows-change="selectionInvoice"
        @select-all="onSelectAllInvoices"
      >
        <template v-slot:emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template v-slot:table-row="props">
          <span v-if="props.column.field === 'invoice_ref'" class="text-nowrap">
            <b>{{ props.row.invoice_ref }}</b
            ><br />
            <template
              v-if="
                props.row.invoive_reste_ref && props.row.invoice_reste_id != 0
              "
            >
              <a
                target="_blank"
                :href="`/edit_invoices/ref/${props.row.invoive_reste_ref}`"
                >{{ props.row.invoive_reste_ref }}</a
              >
            </template>
          </span>
          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            <template v-if="props.row.created_at != null">
              {{ getDate(props.row.created_at) }}<br />
            </template>
            {{ props.row.create_by_name }}
          </span>
          <span
            v-else-if="props.column.field === 'paid_time'"
            class="text-nowrap"
          >
            <template v-if="props.row.paid_time != null">
              {{ getDate(props.row.paid_time) }}<br />
            </template>
            {{ props.row.paid_by_name }}
          </span>
          <span
            v-else-if="props.column.field === 'total_to_send'"
            class="text-nowrap"
          >
            <b>{{ props.row.total_to_send }}</b>
            {{ $devis }}
          </span>
          <template v-else-if="props.column.field === 'customer_name'">
            <div class="text-nowrap">
              <b v-if="props.row.client">{{ props.row.client.store }}<br /></b
              >
              {{ props.row.customer_name }}
            </div>
          </template>
          <span v-else-if="props.column.field === 'transfer'">
            <a
              v-if="props.row.virement_ref && props.row.virement_id != 0"
              target="_blank"
              :href="`/edit_transfer/ref/${props.row.virement_ref}`"
              >{{ props.row.virement_ref }}</a
            >
          </span>
          <template v-else-if="props.column.field === 'statut'">
            <span
              v-if="props.row.statut === 0"
              class="badge rounded-pill bg-danger text-capitalize"
            >
              Brouillon
            </span>
            <span
              v-else-if="
                props.row.statut === 1 &&
                props.row.virement_id === 0 &&
                !props.row.virement_ref
              "
              class="badge rounded-pill bg-warning text-capitalize"
            >
              Enregistré
            </span>
            <span
              v-else-if="
                props.row.paid === 1 &&
                props.row.statut === 2 &&
                props.row.virement_id != 0 &&
                props.row.virement_ref
              "
              class="badge rounded-pill bg-success text-capitalize"
            >
              Payé
            </span>
            <span
              v-else-if="props.row.virement_id != 0 && props.row.virement_ref"
              class="badge rounded-pill bg-info text-capitalize"
            >
              Virement
            </span>
          </template>
          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-if="auth.can('ADD_INV')">
                  <router-link
                    class="dropdown-item"
                    :to="`/edit-invoices/${props.row.id}/${props.row.invoice_ref}`"
                  >
                    <i class="flaticon-edit"></i> Modifier
                  </router-link>
                </li>
                <li
                  v-if="
                    props.row.statut === 0 &&
                    props.row.parcels_num === 0 &&
                    auth.can('INV')
                  "
                >
                  <button class="dropdown-item" @click="DestroyFact(props.row)">
                    <i class="flaticon-delete"></i> Supprimer
                  </button>
                </li>
                <li
                  v-if="
                    props.row.statut === 0 &&
                    props.row.parcels_num != 0 &&
                    auth.can('INV')
                  "
                >
                  <button class="dropdown-item" @click="SaveBon(props.row)">
                    <i class="flaticon-diskette"></i> Enregistrer
                  </button>
                </li>
                <li v-if="props.row.statut === 1 && props.row.parcels_num != 0">
                  <button class="dropdown-item" @click="unSaveFact(props.row)">
                    <i class="flaticon-unlock"></i> Ouvrir
                  </button>
                </li>
                <li v-if="props.row.parcels_num != 0">
                  <button
                    class="dropdown-item"
                    style="color: #0500e8 !important"
                    @click="getPDF(props.row)"
                  >
                    <i class="flaticon-file"></i> Télécharger
                  </button>
                </li>
                <li v-if="props.row.virement_ref && props.row.virement_id != 0">
                  <button class="dropdown-item" @click="PDFTransfer(props.row)">
                    <i class="flaticon-menu-1"></i> PDF Virement
                  </button>
                </li>
              </ul>
            </div>
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>

      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="getRecords"
      />
      <hr />
      <div class="row" v-if="rows && rows.length != 0">
        <div class="col-md-12" style="margin-left: 15px">
          <button
            class="btn btn-success mb-1 mb-sm-0 mr-0 mr-sm-1"
            @click="saveInvoices"
          >
            Enregistrer
          </button>
          <button
            class="btn btn-danger mb-1 mb-sm-0 mr-0 mr-sm-1"
            @click="unsavesInvoices"
          >
            Ne Pas Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/axios";
import { defineComponent, onMounted, ref } from "vue";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import moment from "moment";
import Swal from "sweetalert2";
import MyDateRangePicker from "@/components/MyDateRangePicker.vue";
moment.locale("fr");

export default {
  omponents: {
    MyDateRangePicker,
  },
  name: "InvoiceList",
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const columns = [
      { label: "Référence", field: "invoice_ref" },
      { label: "Client", field: "customer_name" },
      { label: "Nom du banque", field: "customer_bank" },
      { label: "Date de création", field: "created_at" },
      { label: "Date de paiement", field: "paid_time" },
      { label: "Statut", field: "statut" },
      { label: "Colis", field: "parcels_num" },
      { label: "Total", field: "total_to_send" },
      // { label: 'Profit', field: 'profit' },
      { label: "Virement", field: "transfer" },
      { label: "Actions", field: "action", width: "180px" },
    ];

    const rows = ref([]);
    const customerList = ref([]);
    const StoresList = ref([]);
    const client_filter = ref({ id: "", name: "" });
    const store_filter = ref({ id: "", name: "" });
    const type_date_filter = ref("");
    const status_filter = ref("");
    const date_filter = ref("");
    const total_filter = ref("");
    const StatusList = ref([]);

    const users = ref({
      searchTerm: "",
      searchCustomer: "",
      searchStatut: "",
      searchSDate: "",
      searchEDate: "",
      searchTypeDate: "",
      searchStore: "",
      searchTotal: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const offset = ref(9);

    const row_ref = ref({});
    const pricePaid = ref(0);
    const selectedRows = ref([]);
    const Invoices = ref([]);
    const rowsCustomer = ref([]);
    const AutoInvoices = ref([]);

    const searchTimeout = ref(null);

    const todayDt = moment();
    const firstDt = moment().subtract(8, "M");
    const selectedDate = ref(null);

    const showCalendarBox = ref(false);

    function showCalendar() {
      showCalendarBox.value = !showCalendarBox.value;
    }

    let debounceTimeout;

    async function filterClients(search, loading) {
      const query = search.trim().toLowerCase();

      if (!query) {
        customerList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/ListCustsFilter`, {
            params: { query },
          });
          customerList.value = res.data;
          customerList.value.unshift({ code: "0", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          customerList.value = [];
        }
      }, 300); // 300ms debounce
    }

    function onSearchStores(search, loading) {
      if (search.length && StoresList.value.length === 0) {
        loading(true);
        api
          .get(`/api/auth/fetchStores`)
          .then(({ data }) => {
            StoresList.value = data;
            loading(false);
          });
      }
    }

    function getDate(value) {
      // If using moment.js
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function resolveUserStatusVariant(status) {
      if (status === 0) return "danger";
      if (status === 1) return "info";
      if (status === 2) return "success";
      return "warning";
    }

    const isLoader = ref(false);

    async function getRecords(page = 1) {
      users.value.current_page = page;
      isLoader.value = true;
      const res = await api.get(
        `/api/auth/invoices_list?searchTerm=${users.value.searchTerm}&searchCustomer=${users.value.searchCustomer}&searchStore=${users.value.searchStore}&searchStatut=${users.value.searchStatut}&searchSDate=${users.value.searchSDate}&searchEDate=${users.value.searchEDate}&searchTypeDate=${users.value.searchTypeDate}&searchTotal=${users.value.searchTotal}&page=${users.value.current_page}&per_page=${users.value.per_page}`
      );
      if (res && res.data) {
        rows.value = res.data.users.data;
        users.value = res.data.users;
        isLoader.value = false;
      }
    }

    function resetFilters() {
      users.value.searchCustomer = "";
      users.value.searchStore = "";
      users.value.searchStatut = "";
      users.value.searchTerm = "";
      users.value.searchSDate = "";
      users.value.searchEDate = "";
      users.value.searchTypeDate = "";
      users.value.searchTotal = "";
      client_filter.value = { id: "", name: "" };
      store_filter.value = { id: "", name: "" };
      type_date_filter.value = "";
      status_filter.value = "";
      total_filter.value = "";
      // If you have a ref for myInput, clear its dateRange
      // if (row_ref.value.myInput && row_ref.value.myInput.dateRange !== undefined) {
      // row_ref.value.myInput.dateRange = {};
      // }
      users.value.current_page = 1;
      getRecords();
    }

    function applyFilters() {
      users.value.searchCustomer = client_filter.value.id;
      users.value.searchStatut = status_filter.value;
      // users.value.searchSDate = row_ref.value.myInput && row_ref.value.myInput.dateRange && row_ref.value.myInput.dateRange.start !== undefined
      // ? convert(row_ref.value.myInput.dateRange.start)
      // : '';
      // users.value.searchEDate = row_ref.value.myInput && row_ref.value.myInput.dateRange && row_ref.value.myInput.dateRange.end !== undefined
      // ? convert(row_ref.value.myInput.dateRange.end)
      // : '';
      users.value.searchTypeDate = type_date_filter.value;
      users.value.searchTotal = total_filter.value;
      users.value.searchStore = store_filter.value.id;
      users.value.current_page = 1;
      getRecords();
    }

    const debounceTimer = ref(null);
    const searchTerm = ref("");

    function handleInput() {
      clearTimeout(debounceTimer.value);
      debounceTimer.value = setTimeout(() => {
        if (!searchTerm.value || searchTerm.value === "") {
          users.value.searchTerm = searchTerm.value;
          applyFilters();
        } else if (searchTerm.value && searchTerm.value.length > 2) {
          users.value.searchTerm = searchTerm.value;
          applyFilters();
        }
      }, 500);
    }

    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

    function getCutomer() {
      api
        .get(`/api/auth/list_cstmr_invoices`)
        .then(({ data }) => {
          rowsCustomer.value = data;
        });
    }

    function DestroyFact(row) {
      isLoader.value = true;
      api
        .post(`/api/auth/destroy_invc/${row.id}`)
        .then(({ data }) => {
          if (data.message === "success") {
            applyFilters();
            showToast("Facture est supprimée", "success");
          } else {
            showToast("Something went wrong! Pleaz try again", "error");
          }
          isLoader.value = false;
        })
        .catch(() => {
          showToast("Something went wrong! Pleaz try again", "error");
          isLoader.value = false;
        });
    }

    async function SaveBon(row) {
      Swal.fire({
        text: "Vous voulez enregistrer cette facture?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await api.post(`/api/auth/save_invc/${row.id}`);
          if (res.data.message === "success") {
            showToast("Facture bien enregistrée", "success");
            applyFilters();
          } else if (
            res.data.message === "not exist" ||
            res.data.message === "no parcel"
          ) {
            showToast("Vous pouvez pas enregistré cette facture", "error");
          } else {
            showToast("Un erreur ! ", "error");
          }
        }
      });
    }

    async function unSaveFact(row) {
      try {
        const res = await api.post(`/api/auth/unsave_invc/${row.id}`);
        if (res.data.message === "success") {
          showToast("Vous Facture bien ouverte", "success");
          applyFilters();
        } else if (
          res.data.message === "not exist" ||
          res.data.message === "no parcel"
        ) {
          showToast("Vous pouvez pas enregistré cette facture", "error");
        } else {
          showToast("Un erreur ! ", "error");
        }
      } catch {
        showToast("Something went wrong! Pleaz try again", "error");
      }
    }

    function selectionInvoice(params) {
      selectedRows.value = params.selectedRows;
    }

    function onSelectAllInvoices(params) {
      selectedRows.value = params.selectedRows;
    }

    function saveInvoices() {
      Invoices.value = [];
      if (selectedRows.value.length > 0) {
        for (let j = 0; j < selectedRows.value.length; ++j) {
          if (
            selectedRows.value[j].statut === 0 &&
            selectedRows.value[j].parcels_num !== 0 &&
            selectedRows.value[j].paid === 0
          ) {
            Invoices.value.push(selectedRows.value[j]);
          }
        }
        const data = new FormData();
        data.append("invoices", JSON.stringify(Invoices.value));
        api
          .post(`/api/auth/save_all_invc`, data)
          .then(({ data: result }) => {
            if (result === "success") {
              applyFilters();
              showToast("Factures bien enregistrées", "success");
            } else if (result === "no invoice") {
              showToast("Vous pouvez pas les enregistrer", "error");
            }
          })
          .catch(() => {
            showToast("Something went wrong! Pleaz try again", "error");
          });
      }
    }

    function unsavesInvoices() {
      Invoices.value = [];
      if (selectedRows.value.length > 0) {
        for (let j = 0; j < selectedRows.value.length; ++j) {
          if (
            selectedRows.value[j].statut === 1 &&
            selectedRows.value[j].parcels_num !== 0 &&
            selectedRows.value[j].paid === 0
          ) {
            Invoices.value.push(selectedRows.value[j]);
          }
        }
        const data = new FormData();
        data.append("invoices", JSON.stringify(Invoices.value));
        api
          .post(`/api/auth/unsave_all_invc`, data)
          .then(({ data }) => {
            if (data.message === "success") {
              applyFilters();
              getCutomer();
              showToast("Vous Factures bien ajouté", "success");
            } else {
              showToast("Vous pouvez ajouter", "error");
            }
            if (data.message === "no invoice") {
              showToast("Aucun colis à facturé", "error");
            }
          })
          .catch(() => {
            showToast("Something went wrong! Pleaz try again", "error");
          });
      }
    }

    function selectCustomer(params) {
      AutoInvoices.value = params.selectedRows;
    }

    function onSelectAllCustomer(params) {
      AutoInvoices.value = params.selectedRows;
    }

    function getPDF(row) {
      api
        .get(`/api/auth/InvoicePdf/${row.id}`, { responseType: "arraybuffer" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, "_blank");
        });
    }

    function PDFTransfer(row) {
      api
        .get(`/api/auth/TransfertPDF/${row.virement_id}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, "_blank");
        });
    }

    onMounted(async () => {
      getRecords();
    });

    const load = ref(false);
    async function autoAddInvoices() {
      Swal.fire({
        text: "Vous voulez vraiment créer des factures automatiquement ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui , Créer",
      }).then(async (resp) => {
        if (resp.isConfirmed) {
          load.value = true;
          try {
            const res = await api.post(`/api/auth/AutoAddInvoice`);
            load.value = false;
            if (res.data.message === "success" || res.data.success) {
              applyFilters();
              showToast("Factures bien crées", "success");
            } else if (res.data.message === "no invoice" || res.data.success === false) {
              showToast("Aucune facture à créer", "error");
            } else {
              showToast("Something went wrong! Pleaz try again", "error");
            }
          } catch (error) {
            load.value = false;
            showToast("Something went wrong! Pleaz try again", "error");
          }
        }
      });
    }

    return {
      columns,
      rows,
      customerList,
      StoresList,
      client_filter,
      store_filter,
      type_date_filter,
      status_filter,
      date_filter,
      total_filter,
      StatusList,
      users,
      offset,
      row_ref,
      pricePaid,
      selectedRows,
      Invoices,
      rowsCustomer,
      AutoInvoices,
      searchTimeout,
      filterClients,
      onSearchStores,
      getDate,
      resolveUserStatusVariant,
      isLoader,
      getRecords,
      resetFilters,
      applyFilters,
      debounceTimer,
      searchTerm,
      handleInput,
      convert,
      getCutomer,
      DestroyFact,
      SaveBon,
      unSaveFact,
      selectionInvoice,
      onSelectAllInvoices,
      saveInvoices,
      unsavesInvoices,
      PDFTransfer,
      getPDF,
      selectCustomer,
      onSelectAllCustomer,
      autoAddInvoices,
      auth,

      showCalendar,
      selectedDate,
      showCalendarBox,

    };
  },
};
</script>